module.exports = __webpack_public_path__ + "b590e103f56756db485c808fa6dacf3c.png";